import { render, staticRenderFns } from "./counter-checkout.vue?vue&type=template&id=70ee35fd&"
import script from "./counter-checkout.vue?vue&type=script&lang=js&"
export * from "./counter-checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports